import React from "react";

import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
} from "reactstrap";

function LandingPage() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("profile-page");
    return function cleanup() {
      document.body.classList.remove("profile-page");
    };
  });
  return (
    <>
        <div className="main">
            {/* Inizio div caratteristiche Node.js */}
            <div className="section section-dark text-center">
                {/* Inizio del container */}
                <Container>
                    {/* Inizio riga caratteristiche */}
                    <Row>
                        {/* Inizio 1° caratteristica */}
                        <Col md="6">
                            <div className="info">
                                {/* Icona */}
                                <div className="icon icon-info">
                                    <i className="nc-icon nc-album-2" />
                                </div>
                                {/* Descrizione */}
                                <div className="description">
                                    <h4 className="info-title">Backend web</h4>
                                    <p className="text-left">
                                    Mi permette di sfruttare Javascript per realizzare dei componenti lato server da far interagire sia con delle App (Android e iOS) sia con delle web app. Il necessario per instaurare una comunicazione client-server viene messo a disposizione da delle apposite librerie o attraverso dei framework come ad esempio Express.js, che può essere integrato nel progetto per permetterci di scrivere codice e realizzare le funzionalità necessarie.
                                    </p>
                                </div>
                            </div>
                        </Col>
                        {/* Fine 1° caratteristica */}

                        {/* Inizio 2° caratteristica */}
                        <Col md="6">
                            <div className="info">
                                {/* Icona */}
                                <div className="icon icon-info">
                                    <i className="nc-icon nc-mobile" />
                                </div>
                                {/* Descrizione */}
                                <div className="description">
                                    <h4 className="info-title text-center">Applicazioni desktop</h4>
                                    <p className="text-left">
                                        Grazie a Node.js esistono modi per utilizzare tecnologie come HTML, CSS e JavaScript al fine di realizzare App desktop multipiattaforma.
                                    </p>
                                </div>
                            </div>
                        </Col>
                        {/* Fine 2° caratteristica */}

                        {/* Inizio 3° caratteristica */}
                        <Col md="6">
                            <div className="info">
                                {/* Icona */}
                                <div className="icon icon-info">
                                    <i className="nc-icon nc-bulb-63" />
                                </div>
                                {/* Descrizione */}
                                <div className="description">
                                    <h4 className="info-title">IoT e domotica</h4>
                                    <p className="text-left">
                                        Grazie alla sua semplicità di programmazione e alla sua estrema efficienza a livello di risorse Node.js è diventato uno scenario ideale per realizzare applicazioni da integrare con dispositivi dedicati all’IoT (Internet of Things) e alla domotica in genereale.
                                    </p>
                                </div>
                            </div>
                        </Col>
                        {/* Fine 3° caratteristica */}

                        {/* Inizio 4° caratteristica */}
                        <Col md="6">
                            <div className="info">
                                {/* Icona */}
                                <div className="icon icon-info">
                                    <i className="nc-icon nc-tv-2" />
                                </div>
                                {/* Descrizione */}
                                <div className="description">
                                    <h4 className="info-title">Gestione dell'OS</h4>
                                    <p className="text-left">
                                    Grazie ad npm è possibile installare alcuni tool utilizzabili nel proprio sistema operativo. Questi tool si possono invocare sia manualmente da riga di comando (CLI) oppure si possono integrare come una normale libreria in un progetto.
                                    </p>
                                </div>
                            </div>
                        </Col>
                        {/* Fine 4° caratteristica */}

                    </Row>
                    {/* Fine riga caratteristiche */}
                </Container>
                {/* Fine del container */}
            </div>
            {/* Fine div caratteristiche Node.js */}

            {/* Inizio div indice */}
            <div className="section section-dark text-center">
                {/* Inizio del container */}
                <Container>
                    <h2 className="title">Indice</h2>
                    <Row>
                    {/* Inizio 1° card */}
                    <Col md="4">
                        <Card className="card-profile card-plain">
                            {/* Inizio dell'immagine */}
                            <div className="card-avatar">
                                <img
                                    alt="..."
                                    src={require("assets/img/Indice/installazione.jpg")}
                                />
                            </div>
                            {/* Fine dell'immagine */}
                            {/* Inizio del contenuto della card */}
                            <CardBody>
                                {/* Nome */}
                                <div className="author">
                                    <CardTitle tag="h4">Installazione</CardTitle>
                                </div>
                            </CardBody>
                            {/* Fine dle contenuto della card */}
                        </Card>
                    </Col>
                    {/* Fine 1° card */}

                    {/* Inizio 2° card */}
                    <Col md="4">
                        <Card className="card-profile card-plain">
                            {/* Inizio dell'immmagine */}
                            <div className="card-avatar">
                                <img
                                    alt="..."
                                    src={require("assets/img/Indice/utilizzo.jpg")}
                                />
                            </div>
                            {/* Fine dell'immagine */}
                            {/* Inizio del contenuto della card */}
                            <CardBody>
                                {/* Nome */}
                                <div className="author">
                                    <CardTitle tag="h4">Argomenti</CardTitle>
                                </div>
                            </CardBody>
                            {/* Fine del contenuto della card */}
                        </Card>
                    </Col>
                    {/* Fine 2° card */}
                    
                    {/* Inizio 3° card */}
                    <Col md="4">
                        <Card className="card-profile card-plain">
                            {/* Inizio dell'immagine */}
                            <div className="card-avatar">
                                <img
                                    alt="..."
                                    src={require("assets/img/Indice/esempi.jpg")}
                                />
                            </div>
                            {/* Fine dell'immagine */}
                            {/* Inizio del contenuto della card */}
                            <CardBody>
                                {/* Nome */}
                                <div className="author">
                                    <CardTitle tag="h4">Esempi</CardTitle>
                                </div>
                            </CardBody>
                            {/* Fine del contenuto della card */}
                        </Card>
                    </Col>
                    {/* Fine 3° card */}
                    </Row>
                </Container>
                {/* Fine del container */}
            </div>
            {/* Fine div indice */}
        </div>
    </>
  );
}

export default LandingPage;
